import { lazy } from 'react';

/*eslint-disable */
const GameLazy = lazy(
  () =>
    import(
      /* webpackChunkName: "game-chessground" */
      './components/Game'
    )
);
/*eslint-enable */

export default GameLazy;
